@if (pageReady) {
  <main class="gs-page">
    <div class="start-service-container">
      <app-page-header [headerData]="pageHeader"></app-page-header>
      <div class="gs-content-container">
        <div class="notification-container width-fix">
          <app-notification></app-notification>
        </div>
        <app-ssm-stepper [process]="process" [step]="step"></app-ssm-stepper>
        <div class="main-content-container">
          <div class="start-form-container">
            <div class="header-section">
              <h2>{{ pageLabels.serviceAddressHeader }}</h2>
              <p>{{ pageLabels.leadText }}</p>
            </div>
            @if (!hasEmail && process === "start") {
              <div class="email-form">
                <h2>{{ pageLabels.emailHeader }}</h2>
                <app-email-form [emailData]="emailFormData"></app-email-form>
                <p class="email-disclaimer">{{ pageLabels.emailDisclaimer }}</p>
              </div>
            }
            <form [formGroup]="zipLookUpForm" class="zip-search-form">
              <mat-form-field appearance="outline" color="primary" class="zip-form-input">
                <mat-label>{{ pageLabels.zipFieldLabel }}</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="ZipCode"
                  maxlength="5"
                  aria-labelledby="zipRequiredError"
                />
                @if (
                  zipLookUpForm.get("ZipCode")?.hasError("required") ||
                  zipLookUpForm.get("ZipCode")?.hasError("invalidZipCode")
                ) {
                  <mat-error id="zipRequiredError">{{ pageLabels.zipError }}</mat-error>
                }
              </mat-form-field>
              <button
                class="gs-form-button-primary contact-button-width"
                mat-flat-button
                color="primary"
                (click)="lookUpAddressesByZip()"
              >
                {{ pageLabels.searchText }}
              </button>
            </form>
            @if (showServiceAddressForm) {
              <div class="service-address-form-container">
                <h2>{{ pageLabels.serviceAreaHeader }}</h2>
                <p>{{ pageLabels.serviceInstructions }}</p>
                <form [formGroup]="serviceAddressForm">
                  <mat-form-field
                    class="start-input"
                    appearance="outline"
                    color="primary"
                    classList="hide-autocomplete"
                  >
                    <mat-label>{{ pageLabels.serviceAddressLabel }}</mat-label>
                    <input
                      formControlName="AddressLineOne"
                      type="text"
                      matInput
                      aria-labelledby="addressLineOneEmptyError"
                      [matAutocomplete]="auto"
                    />
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addressSelectedFromDropdown($event)">
                      @for (address of addressFilteredByCustomerTyping | async; track address) {
                        <mat-option [value]="address"
                          >{{ address.ServiceAddressStreetNumber }} {{ address.ServiceAddressStreetCardinalDirection }}
                          {{ address.ServiceAddressStreetName }} {{ address.ServiceAddressStreetThoroughfare }}
                          {{ address.ServiceAddressStreetDirection }} {{ address.ServiceAddressStreetStructure }} <br />
                          {{ address.ServiceAddressCity }} {{ address.ServiceAddressZipCode }}</mat-option
                        >
                      }
                    </mat-autocomplete>
                    @if (serviceAddressForm.get("AddressLineOne")?.hasError("required")) {
                      <mat-error id="addressLineOneEmptyError">{{ pageLabels.addressError }}</mat-error>
                    }
                  </mat-form-field>
                  <div class="city-state-container">
                    <mat-form-field class="" appearance="outline" color="primary" id="service-cty">
                      <mat-label>{{ pageLabels.cityLabel }}</mat-label>
                      <input formControlName="City" type="text" matInput aria-labelledby="cityEmptyError" />
                      @if (serviceAddressForm.get("City")?.hasError("required")) {
                        <mat-error id="cityEmptyError">{{ pageLabels.cityError }}</mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field class="disabled" appearance="outline" color="primary" id="service-state">
                      <mat-label>{{ pageLabels.stateLabel }}</mat-label>
                      <input formControlName="State" type="text" matInput aria-labelledby="" [readonly]="true" />
                    </mat-form-field>
                  </div>
                  <mat-checkbox
                    class="default-cb"
                    formControlName="UseAsMailingAddress"
                    color="primary"
                    (click)="toggleMailingAddress()"
                    >{{ pageLabels.useSameAddressText }}</mat-checkbox
                  >
                </form>
                @if (showPartialMatchesForm) {
                  <div class="partial-matches-container">
                    <p>{{ pageLabels.selectAddressFromListInstructions }}</p>
                    <form [formGroup]="partialMatchForm">
                      <mat-radio-group
                        class="gs-radio-button"
                        color="primary"
                        formControlName="Address"
                        aria-labelledby="chooseOptionError"
                      >
                        <mat-radio-button [value]="manuallyEnteredAddress" class="start-radio">{{
                          pageLabels.useAddressEnteredOption
                        }}</mat-radio-button>
                        @for (address of partialMatches; track address) {
                          <mat-radio-button [value]="address" class="start-radio">{{
                            address.FullStreetAddress
                          }}</mat-radio-button>
                        }
                        @if (partialMatchForm.get("Address")?.hasError("required") && partialMatchForm.touched) {
                          <mat-error id="chooseOptionError">{{ pageLabels.optionErrorText }}</mat-error>
                        }
                      </mat-radio-group>
                    </form>
                  </div>
                }
                @if (!useServiceAddressAsMailingAddress) {
                  <div class="mailing-address-form-container">
                    <h2>{{ pageLabels.mailingAddressHeader }}</h2>
                    <app-mailing-address
                      [mailingAddressData]="mailingAddressFormData"
                      [unverifiedAddress]="unverifiedAddress"
                      (dataEmitter)="unverifiedAddressData($event)"
                    ></app-mailing-address>
                  </div>
                }
              </div>
            }
          </div>
          @if (process === "move") {
            <div class="side-content">
              <app-ssm-side-panel [panelData]="ssmProcessData" [step]="step"></app-ssm-side-panel>
            </div>
          }
        </div>

        @if (showServiceAddressForm || process === "move") {
          <mat-divider></mat-divider>
          <div class="start-button-container" [class.flex-fix]="process === 'start'">
            @if (process === "move") {
              <a [routerLink]="goBack()">Back</a>
            }
            <button
              id="start-service-submit"
              class="gs-form-button-primary"
              mat-flat-button
              color="primary"
              (click)="handleSubmit()"
            >
              {{ pageLabels.nextButtonText }}
            </button>
          </div>
        }
      </div>
    </div>
  </main>
}
